"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  cdn: 'prod',
  useBusinessHours: true,
  languages: {
    enabled: false,
    backgroundColor: '#ff003e'
  },
  l10n: {
    en: {
      messenger: {
        customText: {
          actionPostbackError: 'An error occurred while processing your action. Please try again.',
          clickToRetry: 'Message not delivered. Click to retry.',
          couldNotConnect: 'Offline. You will not receive messages.',
          couldNotConnectRetry: 'Reconnecting...',
          couldNotConnectRetrySuccess: "You're back online!",
          fileTooLargeError: 'Max file size limit exceeded ({size}).',
          fileTypeError: 'Unsupported file type.',
          formErrorInvalidEmail: 'Email is invalid.',
          headerText: 'How can we help you?',
          inputPlaceholder: 'Type a message.',
          messageError: 'An error occurred while sending your message. Please try again.',
          messageIndicatorTitleSingular: '{count} New Message',
          messageIndicatorTitlePlural: '{count} New Messages',
          messageRelativeTimeDay: '{value}d ago',
          messageRelativeTimeHour: '{value}h ago',
          messageRelativeTimeJustNow: 'Just now',
          messageRelativeTimeMinute: '{value}m ago',
          messageTimestampFormat: 'h:mm A',
          messageDelivered: 'Delivered',
          messageSeen: 'Seen',
          messageSending: 'Sending...',
          messageTooLongError: 'Max message size limit exceeded {size}.',
          notificationSettingsConnected: 'Connected',
          sendButtonText: 'Send',
          unsupportedMessageType: 'Unsupported message type.',
          unsupportedActionType: 'Unsupported action type.',
          soundNotification: 'Sound',
          startConversation: 'Start',
          closeConfirmationMessage: 'Are you sure you want to end the chat?',
          closeConfirmationCancel: 'Cancel',
          closeConfirmationEndChat: 'End Chat'
        }
      },
      systemMessages: {
        conversationCreated: "We're connecting you to an associate right now. We'll let you know as soon as they are connected.",
        participantAccepted: "You've been connected to an associate.",
        participantJoined: 'An associate has joined the chat.',
        participantLeft: 'An associate has left the chat.',
        transferredToParticipant: 'The chat has been transferred. Please wait for another associate to continue the conversation.',
        transferredToGroup: 'The chat has been transferred. Please wait for another associate to continue the conversation.',
        conversationTerminated: 'The conversation has ended.'
      },
      captureFields: [{
        k: 'Question',
        l: "Hi, I'm here to help. Do you have any questions?  ",
        p: ''
      }]
    }
  },
  prepopulatedFields: [],
  messenger: {
    soundNotificationEnabled: true,
    transcriptPrintingEnabled: false,
    menuItems: {
      imageUpload: false,
      fileUpload: false,
      shareLocation: true
    },
    embedded: false,
    businessName: 'LendingClub',
    businessIconUrl: 'https://static.lendingclub.com/www/src/hosted/chatbot/assets/lc-logo.png',
    buttonIconUrl: 'https://static.lendingclub.com/www/src/hosted/chatbot/assets/chat-button-icon.png',
    browserStorage: 'sessionStorage',
    fixedHeader: false,
    displayStyle: 'button',
    customColors: {
      brandColor: '113B5E',
      conversationColor: '29516D',
      actionColor: '29516D'
    }
  },
  clearMessagesTimeout: 20
};
exports.default = _default;
